<template>
    <div class="block-editor reply-trendyol-question">
        <div class="wrapper">
            <section>
                <div class="editor-row-title">{{ $t("message.channel") }}</div>
                <ChannelPicker
                    v-model="clone.channelId"
                    :allowed-types="['trendyol']"
                    :auto-select-first="true"
                />
            </section>

            <section>
                <div class="title">{{ $t("Soru ID") }}</div>
                <div class="text-editor-wrapper">
                    <TiptapEditor
                        :placeholder="$t('Soru ID giriniz')"
                        :show-attributes="true"
                        :show-emoji="true"
                        :max-character-count="1024"
                        v-model="clone.questionId"
                        automation-mode
                    />
                </div>
            </section>

            <section>
                <div class="title">{{ $t("Cevap") }}</div>
                <div class="text-editor-wrapper">
                    <TiptapEditor
                        :placeholder="$t('Cevap giriniz')"
                        :show-attributes="true"
                        :show-emoji="true"
                        :max-character-count="1024"
                        v-model="clone.answer"
                        automation-mode
                    />
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
import ChannelPicker from "../../../../../../components/pickers/ChannelPicker.vue";

const log = log2("ReplyTrendyolQuestion");

export default {
    name: "ReplyTrendyolQuestion",
    components: { TiptapEditor, ChannelPicker },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep(this.value),
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.block-editor.reply-trendyol-question {
    section {
        margin-bottom: 10px;
    }

    .wrapper {
        padding: 30px;

        .title {
            margin-bottom: 10px;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }

        .text-editor-wrapper {
            border-radius: 0px;
            border: 1px solid #fff;
            background: white;

            &:hover {
                border: 1px solid #006cff !important;
            }
        }
    }
}
</style>
